<div class="general-container viewfinder-container w-full">
  <div class="body-content">
    <div class="documents-section py-32 md:px-[16px] md:bg-gray-10/[0.1]">
      <div class="document-list border border-eggplant-100/[0.1] rounded-2xl md:mb-16">
        <div *ngFor="let document of documents" class="document">
          <p [ngClass]="{'selected': document.selected && documents.length > 1 }" class="block font-sans text-eggplant-80 text-l"
            (click)="selectDocument(document.id)">{{ document.name }} (PDF)</p>
        </div>
      </div>
      <div class="document-info">
        <p class="font-sans text-gray-40 text-l">{{ 'INVEST.READ_DOCUMENTS' | translate }}</p>
      </div>
      <div class="pt-24 hidden md:flex justify-center">
        <p *ngIf="currentPage !== undefined && numberOfPages !== undefined"
        class="font-sans text-s border border-eggplant-100/[0.1] text-eggplant-100/[0.4] p-8 rounded-2xl text-center appear">Página {{ currentPage }} de {{ numberOfPages }}</p>
      </div>
    </div>
    <div [ngClass]="{'view-content': btnList, 'view-full-content': !btnList }">
      <div class="view-container">
        <fun-viewer [file]="url" [zoom]="zoom" [maxHeight]="true"
        (pageChangeEvent)="pageChange($event)" (pageNumberEvent)="getNumberOfPages($event)"></fun-viewer>
      </div>
    </div>
  </div>
</div>
<div class="footer flex flex-col-reverse w-full py-48 md:pt-24 md:pb-0 md:px-40 md:flex-row justify-between md:border-t md:border-eggplant-10 gap-8" *ngIf="btnList">
  <div class="md:flex justify-center" *ngIf="hasBackBtn">
      <fun-new-button size="xl" (eventClick)="prev()" icon="arrow-left" [iconPosition]="'left'" [classExtra]="' !w-full '" [buttonType]="'ghost'" title="{{ 'local_invest.go_back' | translate }}" [iconVibibleMobile]="false"></fun-new-button>
  </div>
  <div class="w-full md:w-fit md:flex justify-center content-center">
      <fun-new-button size="xl" (eventClick)="next()" icon="arrow-right" [iconPosition]="'right'" [classExtra]="' !w-full '" [buttonType]="'primaryDark'" title="firmar" [iconVibibleMobile]="false" [responsive]="false" ></fun-new-button>
  </div>
</div>
